import Vue from "vue";
import {
  ShoppingBag,
  MapPin,
  ChevronDown,
  Clock,
  Calendar,
  Search,
  X,
  Trash2,
  Plus,
  Minus,
  CheckCircle2,
  Star,
  ChevronRight,
  ArrowLeft,
  Car,
  Store,
  Circle,
  GripVertical,
  Flame,
  Leaf,
  Loader2,
  Bike,
  PanelRightClose,
  PanelRightOpen,
  Pin,
  PinOff,
  Check,
  AlertCircle,
  ArrowRight,
  CheckCircle,
  ShieldCheck,
  CreditCard,
  DollarSign,
  Lock,
  User,
  HelpCircle,
  MessageSquare,
  FileImage,
  Image
} from "lucide-vue";

// Register Lucide icons globally
const icons = {
  ShoppingBag,
  MapPin,
  ChevronDown,
  Clock,
  Calendar,
  Search,
  X,
  Trash2,
  Plus,
  Minus,
  CheckCircle2,
  Star,
  ChevronRight,
  ArrowLeft,
  Car,
  Store,
  Circle,
  GripVertical,
  Flame,
  Leaf,
  Loader2,
  Bike,
  PanelRightClose,
  PanelRightOpen,
  Pin,
  PinOff,
  Check,
  AlertCircle,
  ArrowRight,
  CheckCircle,
  ShieldCheck,
  CreditCard,
  DollarSign,
  Lock,
  User,
  HelpCircle,
  MessageSquare,
  FileImage,
  Image
};

// Register all icons as global components
Object.keys(icons).forEach((name) => {
  Vue.component(name, icons[name]);
});

export default icons;
